// extracted by mini-css-extract-plugin
export default {"icon":"TitleText_icon__fGPeU","likeAnimation":"TitleText_likeAnimation__JO7j6"};